module.exports = __webpack_public_path__ + "img/2017-3.6cea2c78.jpg";